import { UnaryFunction } from '@kofno/piper';

export function cond<T, U = T, R = T>(
  predicate: UnaryFunction<T, boolean>,
  truthfn: UnaryFunction<T, U>,
  falsefn: UnaryFunction<T, R>,
): UnaryFunction<T, U | R> {
  return (t: T) => (predicate(t) ? truthfn(t) : falsefn(t));
}
